import type { TransformedTokenGrouped, TransformedTokenMerged } from './types';

export const filterTokens: <T extends TransformedTokenGrouped | TransformedTokenMerged>(
	list: Array<T>,
	filters: {
		showStates?: string[];
	},
) => Array<T> = <T extends TransformedTokenGrouped | TransformedTokenMerged>(
	list: Array<T>,
	filters: {
		showStates?: string[];
	},
): Array<T> =>
	list.filter(({ attributes }) =>
		filters?.showStates?.some((state) => state === attributes?.state),
	);
